export const getFeedbackPreview = async postProcessUuid => {
  if (!postProcessUuid) {
    throw new Error('postProcessUuid is required to fetch feedback preview');
  }

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const url = `${baseUrl}/api/v1/project/get_feedback_preview/?post_process_uuid=${
    encodeURIComponent(postProcessUuid)}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch feedback preview: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data;
};

export default getFeedbackPreview;
